<template>
  <li
    class="tw-text-md :after:tw-font-normal after:tw-pl-1 after:tw-pr-1 [&:not(:last-child)]:after:tw-content-['/']"
  >
    <button
      :class="
        isLink ? 'tw-font-bold tw-text-secondary-500' : 'tw-cursor-default'
      "
      @click="$emit('on-click')"
      :data-test-id="testId"
    >
      <slot />
    </button>
  </li>
</template>

<script lang="ts" setup>
type Props = {
  testId?: string;
  isLink?: boolean;
};

withDefaults(defineProps<Props>(), {
  testId: "cl-breadcrumbs-item",
  isLink: true,
});

defineEmits<{
  (event: "on-click"): void;
}>();
</script>
